/** 终端部署 / 预览页安装包下载共用的平台角标（*-s.svg） */
export const DEPLOY_PACKAGE_ICONS = {
  windows: 'views/dashboard/group/client-alive/_images/wind-s',
  winServer: 'views/dashboard/group/client-alive/_images/win-s',
  macos: 'views/dashboard/group/client-alive/_images/ios-s',
  linux: 'views/dashboard/group/client-alive/_images/linux-s',
  linuxTongxin: 'views/dashboard/group/client-alive/_images/tx-s',
  linuxQilin: 'views/dashboard/group/client-alive/_images/ql-s',
} as const
